import reducerRegistry from 'reduxUtils/reducerRegistry';
import makeRequest from 'utils/makeRequest';

const getFeedURL = (authorID, hostID, isWapView) =>
  `https://jarvis.indiatimes.com/v1/feeds/toi/author_pages?platform=${
    isWapView ? 'mweb' : 'web'
  }&site=${hostID === 428 ? 'reviews' : 'toi'}&author_id=${authorID}`;

const reducerName = 'authorpage';
const createActionName = name => `toi/${reducerName}/${name}`;

export const RECEIVE_AUTHOR_PAGE_DATA = createActionName(
  'RECEIVE_AUTHOR_PAGE_DATA',
);
export const RECEIVE_AUTHOR_PAGE_ERROR = createActionName(
  'RECEIVE_AUTHOR_PAGE_ERROR',
);

export const DATA_LOADING = createActionName('DATA_LOADING');

export const DATA_LOADED = createActionName('DATA_LOADED');

export function dataLoading() {
  return {
    type: DATA_LOADING,
    payload: {},
  };
}

export function dataLoaded() {
  return {
    type: DATA_LOADED,
    payload: {},
  };
}

function handleAuthorPageDataError() {
  return {
    type: RECEIVE_AUTHOR_PAGE_ERROR,
    payload: {},
  };
}

function fetchAuthorPageData(params) {
  const { id, isReviewsPage, isWapView } = params;
  const url = getFeedURL(id, isReviewsPage ? 428 : 83, isWapView);
  return makeRequest.get(url, params);
}
export function receiveAuthorPageData(data) {
  return {
    type: RECEIVE_AUTHOR_PAGE_DATA,
    payload: data,
  };
}

export function loadAuthorDetails(params) {
  return dispatch => {
    dispatch(dataLoading());
    return fetchAuthorPageData(params)
      .then(response => {
        dispatch(dataLoaded());
        dispatch(receiveAuthorPageData(response.data, params));
      })
      .catch(error => {
        dispatch(dataLoaded());
        dispatch(handleAuthorPageDataError(error));
      });
  };
}

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case DATA_LOADING: {
      return {
        ...state,
        dataLoading: true,
      };
    }
    case DATA_LOADED: {
      return {
        ...state,
        dataLoading: false,
      };
    }
    case RECEIVE_AUTHOR_PAGE_DATA: {
      return {
        ...state,
        ...action.payload,
      };
    }

    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
